import React from 'react';
import { Dialog, DialogActions, DialogContent, DialogTitle, 
    Button, Typography 
} from '@mui/material';

const DeleteConfirm = ({ open, onClose, onConfirm, deleteType }) => {
    const handleConfirm = () => {
        onConfirm();
        onClose();
    };

    return (
        <Dialog open={open} onClose={onClose}>
            <DialogTitle color="primary">Confirm {deleteType === 'bulk' ? 'Bulk' : 'Single'} Deletion</DialogTitle>
            <DialogContent>
                <Typography>
                {deleteType === 'bulk'
                    ? 'Are you sure to delete the selected items? This action cannot be undone.'
                    : 'Are you sure to delete this item? This action cannot be undone.'}
                </Typography>
            </DialogContent>
            <DialogActions>
                <Button variant="outlined" color="primary" onClick={onClose}>
                    Cancel
                </Button>
                <Button variant="outlined" color="secondary" onClick={handleConfirm}>
                    Delete
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default DeleteConfirm;
